import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { getSvgStyles } from 'baseui/icon';
import { styled } from '../../../theme/utils.js';
import { Icon } from '../icon.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Svg = forwardRef((_a, ref) => {
  var _b = _a, { title, titleId } = _b, props = __objRest(_b, ["title", "titleId"]);
  return jsxs("svg", __spreadProps(__spreadValues({}, props), { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", ref, "aria-labelledby": titleId, children: [title ? jsx("title", { id: titleId, children: title }) : null, jsx("path", { fill: "currentColor", fillRule: "evenodd", d: "M8.00015 10.9998C8.00015 8.79435 9.79465 6.99985 12.0002 6.99985C14.2057 6.99985 16.0002 8.79435 16.0002 10.9998C16.0002 13.2053 14.2057 14.9998 12.0002 14.9998C9.79465 14.9998 8.00015 13.2053 8.00015 10.9998ZM10.0002 10.9998C10.0002 12.1028 10.8972 12.9998 12.0002 12.9998C13.1032 12.9998 14.0002 12.1028 14.0002 10.9998C14.0002 9.89685 13.1032 8.99985 12.0002 8.99985C10.8972 8.99985 10.0002 9.89685 10.0002 10.9998Z", clipRule: "evenodd" }), jsx("path", { fill: "currentColor", fillRule: "evenodd", d: "M3 11C3 6.0375 7.0375 2 12 2C16.963 2 21 6.0375 21 11C21 15.701 15.9655 20.1955 13.672 22H10.3285C8.035 20.1955 3 15.701 3 11ZM5 11C5 14.7505 9.6145 18.981 11.995 20.764C13.7485 19.4345 19 15.108 19 11C19 7.14 15.86 4 12 4C8.1405 4 5 7.14 5 11Z", clipRule: "evenodd" })] }));
});
const StyledSvg = styled(Svg, getSvgStyles);
const overrides = {
  Svg: {
    component: StyledSvg
  }
};
const IconLocation = forwardRef((props, ref) => jsx(Icon, __spreadValues({ ref, overrides }, props)));
IconLocation.displayName = "IconLocation";

export { IconLocation };
